export const ANIMATION_SCALE = 1

export const breakpoint = {
  tablet: 768,
  laptop: 992,
  desktop: 1440
} as const

export const device = {
  tablet: `(min-width: ${breakpoint.tablet}px)`,
  laptop: `(min-width: ${breakpoint.laptop}px)`,
  desktop: `(min-width: ${breakpoint.desktop}px)`
} as const
